


const nodeEnv = process.env.NODE_ENV;
const freeTechEnv = process.env.VITE_FREETECH_ENV;
let functionsEnv: string = nodeEnv || "development";

if (window.location.hostname === "localhost") {
  if (freeTechEnv === "staging") {
    functionsEnv = "test";
  } else {
    functionsEnv = "development";
  }
} else if (window.location.hostname.includes("stg")) {
  functionsEnv = "staging";
} else {
  functionsEnv = "production";
}


const functionsUrls = {
  production: "https://us-central1-freetech-production.cloudfunctions.net",
  staging: "https://us-central1-freetech-stg.cloudfunctions.net",
  development: "http://127.0.0.1:5001/freetech-production/us-central1",
  test: "http://127.0.0.1:5001/freetech-stg/us-central1",
};

const envUrls = {
  production: "https://api.freetech.co/api/v1",
  staging: "https://stg.api.freetech.co/api/v1",
  development: "http://localhost:8080/api/v1",
  test: "http://localhost:8080/api/v1",
};

const notificationServerUrls = {
  production: "https://notiserver.freetech.co/api",
  staging: "https://stg.notiserver.freetech.co/api",
  development: "http://localhost:8081/api",
  test: "http://localhost:8081/api",
};


export const apiBaseUrl =
  envUrls[functionsEnv as keyof typeof envUrls] || envUrls.development;

export const notificationServerBaseUrl =
  notificationServerUrls[functionsEnv as keyof typeof notificationServerUrls] ||
  notificationServerUrls.development;

export const firebaseFunctionsBaseUrl =
  functionsUrls[functionsEnv as keyof typeof functionsUrls] ||
  functionsUrls.development;


